import React from 'react'
import PropTypes from 'prop-types';
import Select from "components/Select";

function SwzGeneratorQuestionSelect(
    {
        id,
        question,
        formikProps
    }) {
    return (
        <Select
            key={question.key}
            id={question.key.replace(/\./g, '#')}
            formikProps={formikProps}
            items={question.options.map(x => ({label: x.text, value: x.selectValue}))}
        />
    )
}

SwzGeneratorQuestionSelect.propTypes = {
    classes: PropTypes.any,
}

export default SwzGeneratorQuestionSelect;